import React, { useState, useEffect } from "react";
import { Header } from "../common/Header";
import { Menunav } from "../common/Menunav";
import { Sidebar } from "../common/Sidebar";
import { useNavigate, useParams } from "react-router-dom";
import api from "../../utils/api";
import { useDispatch, useSelector } from "react-redux";
// import {Link } from 'react-router-dom';
import "./projects.css";
import { Typography } from "@mui/material";
import { Box } from "@mui/system";
import Swal from "sweetalert2";
import * as filestack from "filestack-js";
const swalWithBootstrapButtons = Swal.mixin({
  customclassName: {
    confirmButton: "btn btn-success",
    cancelButton: "btn btn-danger",
  },
  buttonsStyling: false,
});

function onlyLettersAndSpaces(str) {
  return /^[A-Za-z\s]*$/.test(str);
}

function onlyNumber(str) {
  return /^\d+$/.test(str);
}
export const Postproject = () => {
  let navigate = useNavigate();
  let params = useParams();
  const userstate = useSelector((state) => state.loginUserReducer);
  const [projectImage, setProjectImage] = useState("");
  const { currentUser } = userstate;
  const [data, setData] = useState({});
  const [skills, setSkills] = useState([]);
  const [errors, setErrors] = useState({});
  const [projectFile, setProjectFile] = useState(null);

  // useEffect(() => {
  //   if (params?.projectId) {
  //     api
  //       .get(`/projects/by-id/${params.projectId}`)
  //       .then((res) => {
  //         if (res.data) {
  //           console.log("project for edit", res.data);
  //           // setQuestion(res.data?.question);
  //           // setDescription(res.data?.description);
  //           setProjectImage(res.data?.projectImage);
  //           setSkills(res.data?.skills);
  //           // setPhoneValue(res.data?.contact);
  //           let temp = {
  //             title: res.data?.title,
  //             projectImage: res.data?.projectImage,
  //             projectType: res.data?.projectType,
  //             deadline: res.data?.deadline,
  //             price: res.data?.price,
  //             skills: res.data?.skills,
  //             description: res.data?.description,
  //           };
  //           console.log("temp", temp);
  //           setData(temp);
  //           // setSkills(res.data?.skills);
  //         }
  //       })
  //       .catch((err) => console.log);
  //   }
  // }, []);

  const onChange = (e) => {
    let temp = Object.assign(data, { [e.target.name]: e.target.value });
    setData(temp);
    console.log("updated data>> ", temp);
    if (e.target.name == "skillsText") {
      const Array = e.target.value?.split(",");
      let Array2 = Array.filter((arr) => arr !== "");
      setSkills(Array2);
    }
  };
  const submitToFileStack = (e) => {
    console.log("running on change file stack");
    const client = filestack.init("AdMqjDEfnTReoAz7UMbqxz");
    if (projectFile) {
      client.upload(projectFile).then((data) => {
        console.log("uploaded file url", data.url);
        let e = {
          target: {
            name: "projectFileUrl",
            value: data.url,
          },
        };
        onChange(e);
      });
    }
  };
  const uploadProjectImage = async (e) => {
    console.log("e.targte", e.target);
    console.log("running upload file ");
    let files = e.target.files;
    if (files?.length > 0) {
      const dataa = new FormData();
      dataa.append("file", files[0]);
      dataa.append("upload_preset", "bpyoqbty");

      const res = await fetch(
        "https://api.cloudinary.com/v1_1/dqmbkvawu/image/upload",

        {
          method: "POST",
          body: dataa,
        }
      );
      const file = await res.json();
      console.log("response from cloudinary>>>", file);
      setProjectImage(file?.secure_url);

      let e2 = { target: { name: "projectImage", value: file?.secure_url } };
      onChange(e2);
    }

    // console.log("file profie image>>> ", file);
  };
  const submitData = (e) => {
    console.log("project data to submit", data, skills);

    e.preventDefault();
    console.log("submit");
    let errs = {};
    if (!data.title) {
      errs.title = "required";
    } else if (!onlyLettersAndSpaces(data.title)) {
      errs.title = "must contain letters only";
    }
    if (!data.deadline) {
      errs.deadline = "required";
    }
    if (new Date(data.deadline) < new Date(Date.now())) {
      errs.deadline = "Old date not allowed";
    }
    if (!data.projectFileUrl) {
      errs.projectFileUrl = "required";
    }
    if (!data.paymentBy) {
      errs.paymentBy = "required";
    }

    if (!data.price) {
      errs.price = "required";
    } else if (!onlyNumber(data.price)) {
      errs.price = "must contain number only";
    }
    if (!data.projectType) {
      errs.projectType = "required";
    }
    if (!data.description) {
      errs.description = "required";
    }
    // if (!data.projectImage) {
    //   errs.projectImage = "image is required";
    // }
    if (!data.tech_used) {
      errs.tech_used = "Technology is required";
    }
    if (!data.skillsText && !params.projectId) {
      errs.skills = "skills are required";
    }
    if (skills.length < 2 || skills.length > 5) {
      errs.skills = "atleast 2 skills are required , atmost 5";
    }
    setErrors(errs);
    console.log("errors", errs);

    if (Object.keys(errs).length === 0 && errs.constructor === Object) {
      // let body = Object.assign(data, { userId: currentUser?.id });
      let body = {
        userId: currentUser?.id,
        title: data?.title,
        projectImage: data?.projectImage,
        projectType: data?.projectType,
        deadline: data?.deadline,
        price: data?.price,
        tech_used: data?.tech_used,
        paymentBy: data?.paymentBy,
        skills: skills,
        description: data?.description,
        projectFileUrl: data?.projectFileUrl,
      };
      if (params?.projectId) {
        api
          .put(`/projects/update/${params?.projectId}`, body)
          .then((res) => {
            if (res.data) {
              Swal.fire("Project Updated Successfully!", "", "success");
              navigate("/my-projects");
            }
          })
          .catch((err) => {
            // alert("projects post failed");
            swalWithBootstrapButtons.fire(
              "project Updation Unsuccessful!",
              "Something goes wrong",
              "error"
            );
          });
      } else {
        console.log("submitting data", body);
        api
          .post("/projects", body)
          .then((res) => {
            console.log("response", res.data);
            Swal.fire("Project Uploaded Successfully!", "", "success");
            if (res?.data) {
              let notifBody = {
                userId: currentUser?.id,
                text: `${currentUser?.name} post new project.`,
              };
              api
                .post("/notifications", notifBody)
                .then((re) => console.log("notif", re.data));
              navigate("/projects");
            }
          })
          .catch((err) => {
            console.log(err);
            swalWithBootstrapButtons.fire(
              "Project Uploading Unsuccessful!",
              "Something goes wrong",
              "error"
            );
          });
      }
    }
  };
  useEffect(() => {
    submitToFileStack();
  }, [projectFile]);

  /***refill form if edit */
  useEffect(() => {
    api
      .get("/projects/by-id/" + params?.projectId)
      .then((res) => {
        console.log("response from projects", res?.data);
        setData(res?.data);
        setSkills(res?.data?.skills);
      })
      .catch((err) => console.log(err));
  }, [params?.projectId]);

  return (
    <div>
      {/* <Header />
      <Menunav /> */}
      <div className="row">
        {/* <div className="col-md-2 col-0">
          <Sidebar />
        </div> */}
        <div className="col-md-10 col-12">
          <div className="container p-4">
            <Typography
              variant="h6"
              sx={{ fontWeight: "600", marginBottom: "20px" }}
            >
              {params?.projectId ? "edit your project" : "Post a Project"}
            </Typography>
            <div className="form">
              <div className="row">
                <div className="col-lg-6 col-md-6 col-12">
                  <input
                    className="text-feild input__field__asc firstdiv_of_projects"
                    id="title"
                    placeholder="Title*"
                    name="title"
                    defaultValue={data?.title}
                    required
                    onChange={(e) => onChange(e)}
                  />
                  {errors.title && (
                    <p className="error__para">{errors.title}</p>
                  )}
                </div>
                <div className="col-lg-6 col-md-6 col-12">
                  <input
                    className="text-feild input__field__asc firstdiv_of_projects"
                    id="price"
                    placeholder="Price*"
                    name="price"
                    defaultValue={data?.price}
                    required
                    type="number"
                    min="0"
                    onChange={(e) => onChange(e)}
                  />
                  {errors.price && (
                    <p className="error__para">{errors.price}</p>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-lg-6 col-md-6 col-12">
                  <input
                    className="text-feild input__field__asc firstdiv_of_projects"
                    id="tech_used"
                    placeholder="Technolgy/Stack used to develop*"
                    name="tech_used"
                    required
                    defaultValue={data?.tech_used}
                    type="text"
                    onChange={(e) => onChange(e)}
                  />
                  {errors.tech_used && (
                    <p className="error__para">{errors.tech_used}</p>
                  )}
                </div>

                <div className="col-lg-6 col-md-6 col-12">
                  {/* <input
                    className="text-feild input__field__asc firstdiv_of_projects"
                    id="projectType"
                    placeholder="Project Type"
                    name="projectType"
                    required
                    onChange={(e) => onChange(e)}
                  /> */}
                  <select
                    className="p-2 border border-dark rounded my-2 w-full text-feild input__field__asc"
                    name="projectType"
                    onChange={(e) => onChange(e)}
                    defaultValue={data?.projectType}
                  >
                    <option value="">Project Type</option>
                    <option value="Mobile Application">
                      Mobile Application
                    </option>
                    <option value="Web Application">Web Application</option>
                    <option value="Desktop Application">
                      Desktop Application
                    </option>
                    <option value="Game Development">Game Development</option>
                    <option value="Research Work">Research Work</option>
                    <option value="Data Science">Data Science</option>
                    <option value="Machine Learning">Machine Learning</option>
                    <option value="Artificial Intelligence">
                      Artificial Intelligence
                    </option>
                  </select>
                  {errors.projectType && (
                    <p className="error__para">{errors.projectType}</p>
                  )}
                </div>
              </div>
              <div className="row">
                <Typography variant="p">Select file(pdf or doc)</Typography>
                <Box className="col-lg-4 col-12" sx={{ alignItems: "center" }}>
                  {/* {data?.projectFileUrl ? (
                    <a href={data?.projectFileUrl}>file</a>
                  ) : (
                    <></>
                  )} */}
                  <input
                    className="p-2 border border-dark rounded my-2 w-full text-feild input__field__asc"
                    type="file"
                    onChange={(e) => setProjectFile(e.target.files[0])}
                  />

                  {errors.projectFileUrl && (
                    <p className="error__para">{errors.projectFileUrl}</p>
                  )}
                </Box>
                {/* <Box className="col-lg-4 col-12" sx={{ marginTop: "-10px" }}>
                  <button
                    className="asc__submit__form__button"
                    onClick={(e) => submitToFileStack(e)}
                    disable={projectFile ? true : false}
                  >
                    Upload Project File
                  </button>
                </Box> */}
              </div>
              <div className="row">
                <Box className="col-lg-6 col-md-6 col-12">
                  <select
                    className="text-feild  input__field__asc firstBox_of_projects"
                    name="paymentBy"
                    required
                    onChange={(e) => onChange(e)}
                    defaultValue={data?.paymentBy}
                  >
                    <option>Payment By</option>
                    <option value="pay per hour">pay per hour</option>
                    <option value="pay per project">pay per project</option>
                    <option value="pay fix price">pay fix price</option>
                  </select>
                  {errors.paymentBy && (
                    <p className="error__para">{errors.paymentBy}</p>
                  )}
                </Box>
                <div
                  className="col-lg-6 col-md-6 col-12"
                  style={{
                    display: "flex",
                    alignItems: "center",
                    gap: "5px",
                    height: "60px",
                  }}
                >
                  {/* <label>Deadline</label> */}
                  <input
                    className="text-feild input__field__asc firstdiv_of_projects"
                    id="deadline"
                    placeholder="Deadline*"
                    defaultValue={data?.deadline}
                    name="deadline"
                    required
                    type="text"
                    onFocus={(e) => (e.target.type = "date")}
                    onBlur={(e) => (e.target.type = "text")}
                    onChange={(e) => onChange(e)}
                  />
                  {errors.deadline && (
                    <p className="error__para">{errors.deadline}</p>
                  )}
                </div>
              </div>
              {/* <div
                className="row mt-2"
                style={{ display: "flex", flexDirection: "column" }}
              >
                <label>Upload image</label>
                <input
                  className="text-feild input__field__asc input-file firstdiv_of_projects"
                  type="file"
                  placeholder="upload image"
                  onClick={(e) => uploadProjectImage(e)}
                />
                {projectImage && (
                  <img
                    src={projectImage}
                    style={{ margin: "3vh 3vw", width: "auto", height: "30vh" }}
                  />
                )}
                {errors.projectImage && (
                  <p className="error__para">{errors.projectImage}</p>
                )}
              </div> */}
              <input
                className="text-feild input__field__asc"
                id="skillsText"
                placeholder="Required Skills (seperated by commas)"
                name="skillsText"
                required
                onChange={(e) => onChange(e)}
              />
              {errors.skills && <p className="error__para">{errors.skills}</p>}
              <p>Required Skills : </p>
              {skills && (
                <div className="tags__container">
                  {skills.map((skill) => (
                    <span>{skill} </span>
                  ))}
                </div>
              )}
              <textarea
                className="text-feild input__field__asc"
                id="description_of_hostel"
                placeholder="Description"
                name="description"
                required
                defaultValue={data?.description}
                onChange={(e) => onChange(e)}
              />
              {errors.description && (
                <p className="error__para">{errors.description}</p>
              )}

              <div name="date" id="date" required />
              <button
                className=" asc__submit__form__button cancel__form__btn"
                onClick={() => navigate("/projects")}
              >
                Cancel
              </button>

              <button
                className=" mt-3 asc__submit__form__button"
                id="submitbutton_of_projects "
                onClick={(e) => submitData(e)}
              >
                {params?.projectId ? "update" : "submit"}
              </button>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};
